import script from "./ResourceList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__